module.exports = __webpack_public_path__ + "download_app/es-US/images/download_app_2x-5c22d71f06c3a008424108ea3ccc5ac0.png";


//////////////////
// WEBPACK FOOTER
// ./download_app/es-US/images/download_app_2x.png
// module id = jwWt
// module chunks = 14